import type { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { Footnote1, Title3 } from '@sbol/nova';
import { Button } from '../../lib/ui/Button';
import ConstructionZoneImg from './img/construction_zone.svg?react';
import styles from './ErrorView.module.scss';

export const TechnicalErrorView: FC = observer(() => (
  <div className={styles.ErrorView}>
    <ConstructionZoneImg />
    <Title3 className={styles.Title}>Технические неполадки</Title3>
    <Footnote1 color="secondary" className={styles.Subtitle}>
      Это временно, скоро всё поправим
    </Footnote1>
    <Button className={styles.Button} text={import.meta.env.VITE_SBER_LINK_TEXT} href={import.meta.env.VITE_SBER_LINK} isLink />
  </div>
));
